import { render, staticRenderFns } from "./AddRuleModal.vue?vue&type=template&id=270f62cc&"
import script from "./AddRuleModal.vue?vue&type=script&lang=js&"
export * from "./AddRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddRuleModal.vue?vue&type=style&index=0&id=270f62cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports